import { render, staticRenderFns } from "./ComplexMuseumList.vue?vue&type=template&id=152dcbb8&scoped=true"
import script from "./ComplexMuseumList.vue?vue&type=script&lang=js"
export * from "./ComplexMuseumList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152dcbb8",
  null
  
)

export default component.exports